import {
    getAdminSetting,
    setDateFormat,
    setTimeZone
    
    ,getWorkflowList
    , setGetWorkListError
    , getServicetypelist
    , getServicetypelistError
    , setsave
} from '../constants/model-reducers/admin-setting.settings';
import { httpGet, httpPost } from '../utils/api.utils';

const defaultState = () => ({
    adminSettingId: 0,
    activeDateFormat: {},   
    activeTimeZoneOffset: {},
    dateFormatOptions: [],
    timeZoneOptions: [],
    activeTimeZone: {},
    approvalList: []

});

const initialState = defaultState();

export const adminSettingActions = {
    getAdminSetting: () => async (dispatch) => {
        var result = await httpGet('common/adminsetting');
        sessionStorage.setItem('AdminSetting', JSON.stringify(result));

        dispatch({
            type: getAdminSetting,
            data: result
        });
    },
    saveDateFormat: (dateFormatId) => async (dispatch, state) => {
        try {
            const { adminSettingId } = state().adminSetting;
            var payload = {
                AdminSettingID: adminSettingId,
                DateFormatID: dateFormatId
            };
            var result = await httpPost('common/adminsetting/updateDateFormat/', payload);
            dispatch({
                type: setDateFormat,
                data: result
            });
        }
        catch (ex) {
            return false;
        }
    },

    saveTimeZone: (timeZoneKey) => async (dispatch, state) => {
        try {
            const { adminSettingId } = state().adminSetting;
            var payload = {
                AdminSettingID: adminSettingId,
                TimeZoneID: timeZoneKey
            };
            var result = await httpPost('common/adminsetting/updateTimeZone/', payload);
            dispatch({
                type: setTimeZone,
                data: result
            });
        }
        catch (ex) {
            return false;
        }
    },

    getWorkflowList: () => async (dispatch) => {
        var res = await httpGet('common/adminsetting/getApprovalSetting');
        if (res != null) {

            dispatch({ 
                type: getWorkflowList
                , approvalList: res
                , isGetWorkFlowListLoaded: true,
            })
        } else {
            dispatch({
                type: setGetWorkListError,
                isGetWorkFlowListLoaded: false,
            })
        }
    },

    saveApprovalWorflow: (LastModified, ApprovalWorkflowSettingId, ApprovalWorkFlowId) => async (dispatch, state) => {
     
        try {

            var formData = {
                ApprovalWorkflowSettingId: ApprovalWorkflowSettingId,
                LastModified: LastModified,
                ApprovalWorkflowId: ApprovalWorkFlowId
            };
            var result = await httpPost('common/adminsetting/updateApprovalSetting', formData);
            dispatch({
                type: setsave,
                data: result
            });
        }
        catch (ex) {   
            return false;
        }
    },


    getServicetypelist: () => async (dispatch, state) => {
        var Servicetypelist = await httpGet('common/adminsetting/getWorkflow');
        if (Servicetypelist != null) {
            dispatch({
                type: getServicetypelist,
                Servicetypelist: Servicetypelist          
            });
        } else {
            dispatch({
                type: getServicetypelistError             
            });
        }
    }  
}

export const reducer = (state, action) => {
    state = state || initialState;
       
    switch (action.type) {
        case getAdminSetting:
            return {
                ...state,
                adminSettingId: action.data.AdminSettingID,
                activeDateFormat: action.data.ActiveDateFormat,
                activeTimeZoneOffset: action.data.ActiveTimeZone,
                dateFormatOptions: action.data.DateFormatOptions,
                timeZoneOptions: action.data.TimeZoneOptions,
                activeTimeZone: action.data.TimeZoneId
            };
        case setDateFormat:
            return {
                ...state,
                activeDateFormat: action.data,
            };
        case setTimeZone:
            return {
                ...state,
                activeTimeZoneOffset: action.data,
                activeTimeZone: action.data.TimeZoneId,
            };
        case getServicetypelist:
            return {
                ...state,
                Servicetypelist: action.Servicetypelist
            }
        case getWorkflowList:
            return {
                ...state,
                approvalList: action.approvalList,
                isGetWorkFlowListLoaded: action.isGetWorkFlowListLoaded,
            }
        case setsave:
            return {
                ...state,
                sampleid: action.data.ApprovalWorkflowSettingId,
            };
        default:
            return state;
    }
}